import { CommonModule } from '@angular/common';
import { Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormGroup, FormArray, ReactiveFormsModule } from '@angular/forms';
import { Services } from 'src/app/services/api.service';
import { ErrorMessageService } from 'src/app/services/error-message.util';
import { GdprService } from 'src/app/services/gdpr.service';
import { GetUserProfileService } from 'src/app/services/getUserProfile.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-gdpr-modal',
  templateUrl: `./${environment.pageFolder}/gdpr-modal.${environment.pageFolder}.component.html`,
  styleUrls: [`./${environment.pageFolder}/gdpr-modal.${environment.pageFolder}.component.sass`],
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule]
})

export class GdprModalComponent {
  gdprForm!: FormGroup;
  gdprCheck: boolean = true;
  errorMessage: string = '';
  private readonly destroyRef = inject(DestroyRef);

  constructor(
    private services: Services,
    private gdprService: GdprService,
    private readonly userProfileService: GetUserProfileService,
    private readonly errorMessageService: ErrorMessageService
  ) {}

  ngOnInit() {
    if(!window.location.href.includes('privacy-policy')) {
      this.userProfileService.getUserProfile().pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
        next: profile => {
          this.gdprCheck = profile.gdprCheck;

          if (!this.gdprCheck) {
            this.gdprService.getGdprQuestions().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(form => this.gdprForm = form);
          }
        },
        error: () => {},
      });
    }
  }

  get questionsFormArray() {
    return this.gdprForm?.get('questions') as FormArray;
  }

  onSubmit() {
    if (this.gdprForm.valid) {
      const formValues = this.gdprForm.value.questions;
      let gdprAnswers: string = "";
      formValues.map((question: any) => (
        question.answer && (gdprAnswers = gdprAnswers + (question.questionId.toString() + ','))
      ));

      const body = {
        "gdprTextId":9,
        "gdprAnswers": gdprAnswers
      }

      this.services.postUserGdpr(body).subscribe({
        next: (data: any) => {
          if(data.data === true) {
            this.userProfileService.getUserProfile(true).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
              next: profile => {
                this.gdprCheck = profile.gdprCheck;
              }
            });
          } else {
            this.errorMessage = this.errorMessageService.getErrorMessage('errorWhenSendingData')
          }
        },
        error: error => {
          this.errorMessage = this.errorMessageService.getErrorMessage('errorWhenSendingData')
        }
      });
    } else {
      this.gdprForm.markAllAsTouched();
    }
  }

  logout() {
    this.services.logout();
  }
}
